<template>
  <div>
     <b-modal @hidden="resetModal" ref="modal-new-request" size="lg" centered hide-footer  :no-close-on-backdrop="true" content-class="overflow-hidden">
        <template #modal-title>
           <h5 class="text-primary mb-0 text-dark">
              <i class="bi bi-arrow-left-right me-1 text-primary"></i> New Return &amp; Exchange Request
           </h5>
        </template>
        <div class="row align-items-top">
          <div class="mb-3 col-12 col-md-12">
              <label>Title/Complaint description </label>
              <div class="input-group">
              <input
                v-model.trim="formData.title"
                type="text"
                class="form-control"
                placeholder="Title/Complaint Description"
                name="username"
                :class="{
                'is-invalid':
                modalSubmit && $v.formData.title.$error,
                }"
                />
            </div>
            <div
                v-if="modalSubmit && $v.formData.title.$error"
                class="invalid-feedback d-block"
                >
                <span v-if="!$v.formData.title.required"
                    >Title is required.</span
                    >
              </div>
          
          </div>
          <div class="mb-3 col-12 col-md-12">
              <label class="d-block mb-2">
                <div class="d-flex align-items-center">
                  <div>
                    Complaint Record Form
                    <small class="d-block fw-normal text-muted">
                      Please download and complete the form, then upload it to the system.
                    </small>
                  </div>
                  <div class="ms-auto"><a :href="complaint_form" target="_blank" class="btn btn-sm btn-info ms-2 mb-0 text-nowrap"><i class="bi bi-download me-1"></i> Download</a></div>
                </div>
              </label>

              <div class="card bg-light border shadow-none rounded-3 mb-0" :class="{  'border-purple': complaint_form_file.status == 1, 'border-danger': modalSubmit && $v.formData.document_1.$error }">
                <div class="card-body p-3 py-4">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-4">
                        <div class="avatar-sm">
                          <span class="avatar-title bg-soft-purple rounded-circle text-purple">
                            <i class="bi bi-filetype-pdf font-size-22"></i>
                          </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 align-self-center">
                      <div>
                        <div class="d-flex w-100">
                          <h5 class="font-size-14 mb-1 fw-medium" >
                          {{ complaint_form_file.name }} (.pdf) <span v-if="complaint_form_file.status == 1"> 
                          <i class="bi bi-check-circle-fill text-success font-size-16 ms-2"></i></span>
                          </h5>
                          
                        </div>
                        <p class="text-success mb-2" v-if="complaint_form_file.status == 1">
                          <a
                            :href="complaint_form_file.files"
                            class="ms-1 text-purple"
                            v-b-tooltip.hover
                            :title="complaint_form_file.file_name"
                            v-if="complaint_form_file.files"
                            target="_blank"
                          >
                            <i class="uil uil-import font-size-15"></i>
                            {{ complaint_form_file.file_name }} ({{ complaint_form_file.file_size }})
                          </a>


                          <a href="javascript:void(0)" class="text-danger ms-1" v-if="complaint_form_file.status == 1" @click="
                              complaint_form_file.status=0,
                              complaint_form_file.files= '',
                              complaint_form_file.file_name= '',
                              complaint_form_file.file_size= ''
                              formData.document_1 = ''
                          "><span><i class="bi bi-trash font-size-15"></i> Remove</span>
                          </a>
                        </p>
                        <p class="text-orange" v-if="complaint_form_file.status == 2">
                          <i
                            class="mdi mdi-clock-time-nine-outline text-orange"
                          ></i>
                          Uploading
                          <span class="text-muted ms-1"
                            >{{ complaint_form_file.file_name }} ({{
                              complaint_form_file.file_size
                            }})</span
                          >
                        </p>
                        <!-- <p class="text-muted" v-if="payment_receipt.status == 0">
                          <i class="mdi mdi-alert-circle text-danger"></i>
                          Pending
                        </p> -->
                        <div v-if="uploadLoading && complaint_form_file.status == 2">
                          <div
                            class="Animated progress rounded bg-white"
                            style="height: 26px"
                            role="progressbar"
                            :aria-valuenow="uploadProgress"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated rounded fw-medium font-size-13"
                              :style="`width: ${uploadProgress}%`"
                            >
                              {{ uploadProgress }}%
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <input
                            class="form-control mb-0 mt-1"
                            accept="application/pdf"
                            type="file"
                            :disabled="uploadLoading"
                            :id="complaint_form_file.id"
                            @change="onChangePDF"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <input
                hidden
                v-model.trim="formData.document_1"
                type="text"
                class="form-control"
                placeholder="Complaint form"
                readonly
                name="name"
                :class="{
                'is-invalid': modalSubmit && $v.formData.document_1.$error,
                }"
                />
              <div
                v-if="modalSubmit && $v.formData.document_1.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.formData.document_1.required"
                    >Complaint form is required.</span
                    >
              </div>

             
          </div>

          <div class="mb-0 col-12 col-md-12">
              <label class="mb-2">Supporting Photos  <small class="fw-normal text-muted">(Optional)</small>
                <small class="d-block fw-normal text-muted">Please attach photos showing any damage or problems with the items.</small>
              </label>
              
              <div class="row g-2">
                <div
                  class="col-sm-3 col-6"
                  v-for="(value, index) in formData.photos"
                  :key="index"
                >

                <div class="p-2 rounded-3 square-image" :class="{'border-purple': value.status == 1 }" @click="$refs.photoInput[index].click()">
                    <a :href="value.files" v-if="value.status == 1" target="_blank">
                    <img
                      class="rounded-3 p-1"
                      :src="value.files"
                    />
                    </a>
                   
                    <div v-else class="position-absolute top-50 start-50 translate-middle p-1">
                      <h4 class="fw-normal text-center mb-0 text-muted opacity-50">
                        <i class="bi bi-images display-6"></i>
                      </h4>
                    </div>
                    <div v-if="uploadLoading2 && value.status == 2" class="position-absolute bottom-0 w-100 start-50 translate-middle px-2 pb-0">
                        <div
                          class="Animated progress rounded bg-white"
                          style="height: 16px"
                          role="progressbar"
                          :aria-valuenow="uploadProgress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated rounded fw-medium font-size-13"
                            :style="`width: ${uploadProgress}%`"
                          >
                            {{ uploadProgress }}%
                          </div>
                        </div>
                      </div>
                      <input
                        :id="value.id"
                        ref="photoInput"
                        type="file"
                        accept="image/*"
                        class="form-control form-control-sm"
                        :disabled="uploadLoading2"
                        hidden
                        @change="onChangeFileMultiple"
                      />
                    </div>

                    <div class="text-danger position-absolute bottom-0 w-100 start-50 text-center translate-middle" v-if="value.status == 1">
                    <a href="javascript:void(0)" class="btn btn-sm border-dark btn-dark me-1" @click="
                        value.status=0,
                        value.files= '',
                        value.file_name= '',
                        value.file_size= ''
                    "><span><i class="bi bi-trash font-size-15"></i></span>
                    </a>
                    <a :href="value.files" v-if="value.status == 1" target="_blank" class="btn btn-sm border-dark btn-dark" >
                      <span><i class="bi bi-eye font-size-15"></i></span>
                    </a>
                  </div>
                </div>

             
              </div>
          
          </div>

          
          <div class="col-12">
              <hr>
              <div class="d-grid gap-2 d-md-block text-end">
                 <button type="button" class="order-1 btn fw-medium btn-secondary me-md-2" @click="$refs['modal-new-request'].hide()">Cancel</button>
                 <button type="button" class="btn fw-medium btn-primary" @click="newRequest" :disabled="modalLoading || loading">
                 <span v-if="modalLoading"> Submitting...</span>
                 <span v-else> Submit </span>
                 <span class="spinner-border spinner-border-sm ms-2" v-if="modalLoading" role="status" aria-hidden="true"></span>
                 </button>
              </div>
           </div>
        </div>
     </b-modal>
     <b-modal @hidden="resetModal" ref="modal-update-request" size="lg" centered hide-footer  :no-close-on-backdrop="true" content-class="overflow-hidden">
        <template #modal-title>
           <h5 class="text-primary mb-0 text-dark">
              <i class="bi bi-arrow-left-right me-1 text-primary"></i> Return &amp; Exchange Request #{{ updateData.return_exchanges_id }}
           </h5>
        </template>
        <div class="row align-items-top">
          <div class="mb-3 col-12 col-md-12">
              <label>Title/Complaint description</label>
              <div class="bg-light p-3 rounded-3">
                <p class="text-body mb-0">{{updateData.title}}</p> 
              </div>
            <div
                v-if="modalSubmit && $v.formEditData.title.$error"
                class="invalid-feedback d-block"
                >
                <span v-if="!$v.formEditData.title.required"
                    >Title is required.</span
                    >
              </div>
          
          </div>
          <div class="mb-3 col-12 col-md-12">
              <label class="d-block mb-2">
                <div class="d-flex align-items-center">
                  <div>
                    Complaint Record Form
                    <small class="d-block fw-normal text-muted">
                      Please download and complete the form, then upload it to the system.
                    </small>
                  </div>
                </div>
              </label>

              <div class="card bg-light border shadow-none rounded-3 mb-0 border-purple">
                <div class="card-body p-3">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-4">
                        <div class="avatar-sm">
                          <span class="avatar-title bg-soft-purple rounded-circle text-purple">
                            <i class="bi bi-filetype-pdf font-size-22"></i>
                          </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 align-self-center">
                      <div>
                        <div class="d-flex w-100">
                          <h5 class="font-size-14" >
                          <a :href="formEditData.document_1" class="text-purple fw-medium" target="_blank">Complaint Record Form</a> (.pdf) <span> 
                          <i class="bi bi-check-circle-fill text-success font-size-16 ms-2"></i></span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <input
                hidden
                v-model.trim="formEditData.document_1"
                type="text"
                class="form-control"
                placeholder="Complaint form"
                readonly
                name="name"
                :class="{
                'is-invalid': modalSubmit && $v.formEditData.document_1.$error,
                }"
                />
              <div
                v-if="modalSubmit && $v.formEditData.document_1.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.formEditData.document_1.required"
                    >Complaint form is required.</span
                    >
              </div>
          </div>


          <div class="mb-3 col-12 col-md-12">
              <label class="d-block mb-2">
                <div class="d-flex align-items-center">
                  <div>
                    Complaint Record Form <small class="fw-normal text-purple">(QA Section)</small>
                    <small class="d-block fw-normal text-muted">
                      You may download the complainant's form from the section above, fill it out, and upload it to the system.
                    </small>
                  </div>
                </div>
              </label>

              <div class="card bg-light border shadow-none rounded-3 mb-0 border-purple" v-if="updateData.document_2">
                <div class="card-body p-3 py-3">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-4">
                        <div class="avatar-sm">
                          <span class="avatar-title bg-soft-purple rounded-circle text-purple">
                            <i class="bi bi-filetype-pdf font-size-22"></i>
                          </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 align-self-center">
                      <div>
                        <div class="d-flex w-100">
                          <h5 class="font-size-14" >
                          <a :href="formEditData.document_1" class="text-purple fw-medium" target="_blank">Complaint Record Form (QA Section)</a> (.pdf) <span> 
                          <i class="bi bi-check-circle-fill text-success font-size-16 ms-2"></i></span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card bg-light border shadow-none rounded-3 mb-0" v-else :class="{  'border-purple': complaint_form_qa_file.status == 1 }">
                <div class="card-body p-3 py-4">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-4">
                        <div class="avatar-sm">
                          <span class="avatar-title bg-soft-purple rounded-circle text-purple">
                            <i class="bi bi-filetype-pdf font-size-22"></i>
                          </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 align-self-center">
                      <div>
                        <div class="d-flex w-100">
                          <h5 class="font-size-14 mb-1 fw-medium" >
                          {{ complaint_form_qa_file.name }} (.pdf) <span v-if="complaint_form_qa_file.status == 1"> 
                          <i class="bi bi-check-circle-fill text-success font-size-16 ms-2"></i></span>
                          </h5>
                          
                        </div>
                        <p class="text-success mb-2" v-if="complaint_form_qa_file.status == 1">
                          <a
                            :href="complaint_form_qa_file.files"
                            class="ms-1 text-purple"
                            v-b-tooltip.hover
                            :title="complaint_form_qa_file.file_name"
                            v-if="complaint_form_qa_file.files"
                            target="_blank"
                          >
                            <i class="uil uil-import font-size-15"></i>
                            {{ complaint_form_qa_file.file_name }} ({{ complaint_form_qa_file.file_size }})
                          </a>


                          <a href="javascript:void(0)" class="text-danger ms-1" v-if="complaint_form_qa_file.status == 1" @click="
                              complaint_form_qa_file.status=0,
                              complaint_form_qa_file.files= '',
                              complaint_form_qa_file.file_name= '',
                              complaint_form_qa_file.file_size= ''
                              formData.document_2 = ''
                          "><span><i class="bi bi-trash font-size-15"></i> Remove</span>
                          </a>
                        </p>
                        <p class="text-orange" v-if="complaint_form_qa_file.status == 2">
                          <i
                            class="mdi mdi-clock-time-nine-outline text-orange"
                          ></i>
                          Uploading
                          <span class="text-muted ms-1"
                            >{{ complaint_form_qa_file.file_name }} ({{
                              complaint_form_qa_file.file_size
                            }})</span
                          >
                        </p>
                        <!-- <p class="text-muted" v-if="payment_receipt.status == 0">
                          <i class="mdi mdi-alert-circle text-danger"></i>
                          Pending
                        </p> -->
                        <div v-if="uploadLoading && complaint_form_qa_file.status == 2">
                          <div
                            class="Animated progress rounded bg-white"
                            style="height: 26px"
                            role="progressbar"
                            :aria-valuenow="uploadProgress"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated rounded fw-medium font-size-13"
                              :style="`width: ${uploadProgress}%`"
                            >
                              {{ uploadProgress }}%
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <input
                            class="form-control mb-0 mt-1"
                            accept="application/pdf"
                            type="file"
                            :disabled="uploadLoading"
                            :id="complaint_form_qa_file.id"
                            @change="onChangePDF"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <input
                hidden
                v-model.trim="formEditData.document_2"
                type="text"
                class="form-control"
                placeholder="Complaint form"
                readonly
                />
          </div>
          <div class="mb-3 col-12 col-md-12">
              <label class="mb-2">Supporting Photos  <small class="fw-normal text-muted">(Optional)</small>
                <small class="d-block fw-normal text-muted">Please attach photos showing any damage or problems with the items.</small>
              </label>
              <div v-if="formEditData.photos.filter(e => e.files=='').length==4" class="card bg-white border shadow-none rounded-3 mb-2 p-3">

                <div class="d-flex align-items-center w-100">
                    <div class="flex-shrink-0 me-4">
                        <div class="avatar-sm">
                          <span class="avatar-title bg-soft-secondary opacity-75 rounded-circle text-muted">
                            <i class="bi bi-image font-size-22"></i>
                          </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 align-self-center">
                      <div>
                        <div class="d-flex w-100">
                          <h5 class="font-size-14 fw-normal text-muted"> 
                            No Photo Provided
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

              </div>
              <div class="row g-2">
                <div
                  class="col-sm-3 col-6"
                  v-for="(value, index) in formEditData.photos"
                  :key="index"
                  v-show="value.files"
                >

                <div class="p-2 rounded-3 square-image" :class="{'border-purple': value.status == 1 }">
                    <a :href="value.files" v-if="value.status == 1" target="_blank">
                    <img
                      class="rounded-3 p-1"
                      :src="value.files"
                    />
                    </a>
                   
                    <div v-else class="position-absolute top-50 start-50 translate-middle p-1">
                      <h4 class="fw-normal text-center mb-0 text-muted opacity-50">
                        <i class="bi bi-images display-6"></i>
                      </h4>
                    </div>
                    <div v-if="uploadLoading2 && value.status == 2" class="position-absolute bottom-0 w-100 start-50 translate-middle px-2 pb-0">
                        <div
                          class="Animated progress rounded bg-white"
                          style="height: 16px"
                          role="progressbar"
                          :aria-valuenow="uploadProgress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated rounded fw-medium font-size-13"
                            :style="`width: ${uploadProgress}%`"
                          >
                            {{ uploadProgress }}%
                          </div>
                        </div>
                      </div>
                      <input
                        :id="value.id"
                        ref="photoInput"
                        type="file"
                        accept="image/*"
                        class="form-control form-control-sm"
                        :disabled="uploadLoading2"
                        hidden
                        @change="onChangeFileMultiple"
                      />
                    </div>

                    <div class="text-danger position-absolute bottom-0 w-100 start-50 text-center translate-middle" v-if="value.status == 1">
                    <!-- <a href="javascript:void(0)" class="btn btn-sm border-dark btn-dark me-1" @click="
                        value.status=0,
                        value.files= '',
                        value.file_name= '',
                        value.file_size= ''
                    "><span><i class="bi bi-trash font-size-15"></i></span>
                    </a> 
                    <a :href="value.files" v-if="value.status == 1" target="_blank" class="btn btn-sm border-dark btn-dark" >
                      <span><i class="bi bi-eye font-size-15"></i></span>
                    </a>-->
                  </div>
                </div>
             
              </div>
          
          </div>
          <div class="mb-3 col-12 col-md-12">
              <label>Current Status </label>
              <div>
                <span v-if="updateData.status=='pending'" class="text-orange badge border border-orange fw-medium font-size-14 text-capitalize text-uppercase">{{updateData.status}}</span>
                <span v-if="updateData.status=='approved'" class="text-primary badge border border-primary fw-medium font-size-14 text-capitalize text-uppercase">{{updateData.status}}</span>
                <span v-if="updateData.status=='processing'" class="text-blue badge border border-blue fw-medium font-size-14 text-capitalize text-uppercase">{{updateData.status}}</span>
                <span v-if="updateData.status=='completed'" class="text-success badge border border-success fw-medium font-size-14 text-capitalize text-uppercase"> {{updateData.status}}</span>
                <span v-if="updateData.status=='rejected'" class="text-danger badge border border-danger fw-medium font-size-14 text-capitalize text-uppercase"> {{updateData.status}}</span>
              </div>
          </div>
          <div class="mb-3 col-12 col-md-12">
              <label>Update Status </label>
              <div>
                <div class="input-group">
                  <select class="form-select" v-model="formEditData.status">
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="processing">Processing</option>
                    <option value="completed">Completed</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
                <div
                  v-if="modalSubmit && $v.formEditData.status.$error"
                  class="invalid-feedback d-block"
                  >
                  <span v-if="!$v.formEditData.status.required"
                      >Status is required.</span
                      >
                </div>
                <div class="mt-2" v-if="formEditData.status=='rejected'">
                  <textarea class="form-control" v-model="formEditData.rejected_reason" placeholder="Rejected Reason"></textarea>
                </div>
              </div>
          </div>
          <div class="mb-3 col-12 col-md-12" v-if="updateData.status!=='pending' && updateData.status!=='rejected'">
            <label class="d-block mb-2">
              <div class="d-flex align-items-center">
                <div>
                  <span class="d-block mb-2">
                    Goods Return Note
                  </span>
                  <ol class="ps-4 fw-normal text-muted">
                      <li>
                        Returns will only be accepted with a duly completed Purchase Return Note. A copy of this note MUST be sent with the item/s being returned.
                      </li>
                      <li>
                        Any products returned to Nova without prior authorization from PIC will be considered as an unauthorized return and will not be processed by our office.
                      </li>
                    </ol>
                </div>
              </div>
              <div><a :href="good_return_form" target="_blank" class="btn btn-info mb-0 text-nowrap"><i class="bi bi-download me-1"></i> Download Goods Return Note</a></div>
            </label>
          </div>
          <!-- Logs -->
           <div class="col-12">
            <div class="card border rounded-3 p-3 shadow-none mb-0">
              <label class="mb-2 border-bottom border-primary border-2 pb-2 ">Logs</label>
                <ol class="activity-feed mb-0 ps-2 mt-2 mb-0">
                  <li class="feed-item pb-2" v-for="(value,index) in updateData.status_log" :key="index">
                      <div class="feed-item-list pb-0">
                          <p class="m-0 text-muted">
                            {{value}}
                          </p>
                      </div>
                  </li>
                </ol>
            </div>
           </div>
          
          <div class="col-12">
              <hr>
              <div class="d-grid gap-2 d-md-block text-end">
                 <button type="button" class="order-1 btn fw-medium btn-secondary me-md-2" @click="$refs['modal-update-request'].hide()">Cancel</button>
                 <button type="button" class="btn fw-medium btn-primary" @click="updateRequest" :disabled="modalLoading || loading">
                 <span v-if="modalLoading"> Updating...</span>
                 <span v-else> Update </span>
                 <span class="spinner-border spinner-border-sm ms-2" v-if="modalLoading" role="status" aria-hidden="true"></span>
                 </button>
              </div>
           </div>
        </div>
     </b-modal>
     <Common ref="commonFunc" />
  </div>
</template>

<script>
  import appConfig from "@/app.config";
  import axios from "axios";
  import Swal from "sweetalert2";
  import Common from "@/components/common";
  import { 
    required, 
    minLength
    //url
  } from "vuelidate/lib/validators";
  
  export default {
    components: {
      Common,
    },
    props: {
      data: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        updateData: {},
        accessToken: '',
        accessEmail: '',
        accessPhone: '',
        accessUsername: '',
        account_type: '',
        create_modify_permission:false,
        loading: false,
        modalSubmit: false,
        modalLoading: false,
        passwordFieldType_current: "password",
        classicon_current: "uil uil-eye-slash",
        passwordFieldType: "password",
        classicon: "uil uil-eye-slash",
        passwordFieldType2: "password",
        classicon2: "uil uil-eye-slash",
        returnData: [],
        tabs_index:0,
        complaint_form:"/files/complaint_form.pdf",
        good_return_form:"/files/good_return_form.pdf",
        complaint_form_file:{
          id:1,
          name: "Complaint Record Form",
          status: 0,
          files: "",
          file_name: "",
          file_size: "",
        },
        complaint_form_qa_file:{
          id:2,
          name: "Complaint Record Form (QA Section)",
          status: 0,
          files: "",
          file_name: "",
          file_size: "",
        },
        uploadProgress:0,
        uploadLoading:false,
        uploadLoading2:false,
        formData: {
          title:"",
          status: "pending",
          document_1: "",
          document_2: "",
          photos:[
            {
              id: "P1",
              name: "Photo (1)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P2",
              name: "Photo (2)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P3",
              name: "Photo (3)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P4",
              name: "Photo (4)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            }
          ],
        },
        formEditData: {
          id:"",
          title:"",
          status: "pending",
          document_1: "",
          document_2: "",
          photos:[
            {
              id: "P1",
              name: "Photo (1)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P2",
              name: "Photo (2)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P3",
              name: "Photo (3)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P4",
              name: "Photo (4)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            }
          ],
          rejected_reason:""
        },
        resetPassword: {
          id:"",
          password: "",
          confirmPassword: ""
        },
        currentModules:[]
      };
    },
    validations: {
      formData: {
        title: {
          required
        },
        status: {
          required,
        },
        document_1: {
          required,
        },
        photos:{
          required,
          minLength: minLength(1),
        }
      },
      formEditData: {
        id: {
          required
        },
        title: {
          required
        },
        status: {
          required,
        },
        document_1: {
          required,
        },
        photos:{
          required,
          minLength: minLength(1),
        }
      }
    },
    middleware: "authentication",
    async mounted() {
      this.reload();
    },
    created() {
      
    },
    methods: {
      convertFileSize(fileSize) {
        var formattedFileSize = "";
        if (fileSize < 1024) {
          formattedFileSize = fileSize + " bytes";
        } else if (fileSize < 1048576) {
          // 1024 * 1024
          formattedFileSize = (fileSize / 1024).toFixed(2) + " KB";
        } else if (fileSize < 1073741824) {
          // 1024 * 1024 * 1024
          formattedFileSize = (fileSize / 1048576).toFixed(2) + " MB";
        } else {
          formattedFileSize = (fileSize / 1073741824).toFixed(2) + " GB";
        }
        return formattedFileSize;
      },
      async onChangePDF(e) {
        console.log(e.target.id);
        let file = e.target.files[0];
        console.log(file);
        var data = ""
        if (e.target.id==1){
          data = this.complaint_form_file;
        }else{
          data = this.complaint_form_qa_file;
        }
        data.status = 2
        data.file_name = file.name;
        data.file_size = this.convertFileSize(file.size);
        this.uploadFile(file,data);
        // this.formSuccessData.transactionReceipt = file
        // this.formSuccessData.transactionReceiptFile = file
      },
      uploadFile(value, data) {
        this.$Progress.start();
        this.uploadLoading = true;
        var bodyFormData = new FormData();
        bodyFormData.append("accessToken", this.accessToken);
        bodyFormData.append("accessUsername", this.accessUsername);
        bodyFormData.append("mediaPath", "return_exchanges");
        bodyFormData.append("media", value);
        //bodyFormData.append("size", value.file_size);
      // bodyFormData.append("name", value.file_name);

        axios({
          method: "post",
          url: appConfig.APIHost + 'controller/media/saveMediaFile',
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        })
          .then((response) => {
            var resData = response.data;
            if (resData.status == 200) {
              console.log(resData);
              data.status = 1;
              data.files = resData.media_path;
              console.log("uploaded");
              //upload to the server temporary place first and you return id to me, after that i submit the form you move the data to ori place
            } else if (resData.status == 440) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                html: `${resData.message}.`,
                confirmButtonColor: "#222",
                confirmButtonText: this.$t("siteLang.Done"),
              });
              localStorage.clear();
              this.$router.push({
                path: "/login",
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                html: `${resData.message}.`,
                confirmButtonColor: "#222",
                confirmButtonText: this.$t("siteLang.Done"),
              });
            }
            this.uploadLoading = false;
            this.uploadProgress = 0;
            this.submitted = false;
            this.$Progress.finish();
          })
          .catch((error) => {
            this.uploadLoading = false;
            this.uploadProgress = 0;
            this.submitted = false;
            this.$Progress.finish();
            //Swal.fire("Error", error, "error");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${error}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
          });
      },
      async onChangeFileMultiple(e) {
        console.log(e.target.id);
        let file = e.target.files[0];
        console.log(file);
        this.formData.photos.forEach((element) => {
          if (element.id == e.target.id) {
            element.status = 2;
            element.file_name = file.name;
            element.file_size = this.convertFileSize(file.size);
            element.files = file;
            this.uploadFile2(element);
          }
        });
        // this.formSuccessData.transactionReceipt = file
        // this.formSuccessData.transactionReceiptFile = file
      },
      uploadFile2(value) {
        this.$Progress.start();
        this.uploadLoading2 = true;
        var bodyFormData = new FormData();
        bodyFormData.append("accessToken", this.accessToken);
        bodyFormData.append("accessUsername", this.accessUsername);
        bodyFormData.append("mediaPath", "return_exchanges");
        //bodyFormData.append("id", value.id);
        bodyFormData.append("media", value.files);
        //bodyFormData.append("size", value.file_size);
      // bodyFormData.append("name", value.file_name);

        axios({
          method: "post",
          url: appConfig.APIHost + 'controller/media/saveMediaFile',
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        })
          .then((response) => {
            var resData = response.data;
            if (resData.status == 200) {
              console.log(resData);
              value.status = 1;
              value.files = resData.media_path;
              console.log("uploaded");
              console.log(this.formData.photos);
              //upload to the server temporary place first and you return id to me, after that i submit the form you move the data to ori place
            } else if (resData.status == 440) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                html: `${resData.message}.`,
                confirmButtonColor: "#222",
                confirmButtonText: this.$t("siteLang.Done"),
              });
              localStorage.clear();
              this.$router.push({
                path: "/login",
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                html: `${resData.message}.`,
                confirmButtonColor: "#222",
                confirmButtonText: this.$t("siteLang.Done"),
              });
            }
            this.uploadLoading2 = false;
            this.uploadProgress = 0;
            this.submitted = false;
            this.$Progress.finish();
          })
          .catch((error) => {
            this.uploadLoading2 = false;
            this.uploadProgress = 0;
            this.submitted = false;
            this.$Progress.finish();
            //Swal.fire("Error", error, "error");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${error}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
          });
      },
    
      convertCurrencyFormat(value, show00) {
        if (show00 == true) {
          return this.$refs.commonFunc.convertCurrencyFormat(value)
        } else {
          // Assuming this.transactionLimit is defined in your component's data
          return this.$refs.commonFunc.convertCurrencyFormat(value).replaceAll(".00", "");
        }
      },
      showModal() {
        this.$refs['modal-new-request'].show()
        this.accessToken = this.data.assessToken;
        this.accessUsername = this.data.accessUsername;
        this.updateData = this.data.updateData
        //this.getReseller('create');
      },
      showEditModal() {
        this.$refs['modal-update-request'].show()
        this.accessToken = this.data.assessToken;
        this.accessUsername = this.data.accessUsername;
        this.updateData = this.data.updateData;

       
        this.formEditData={
          id:this.data.updateData.return_exchanges_db_code,
          title: this.data.updateData.title,
          status: this.data.updateData.status,
          document_1: this.data.updateData.document_1,
          document_2: this.data.updateData.document_2,
          photos:this.data.updateData.photos,
          status_log: this.data.updateData.status_log,
          rejected_reason: this.data.updateData.rejected_reason
        }

        
        // this.formEditData =  {
        //   id: this.data.updateData.account_db_code,
        //   username: this.data.updateData.username,
        //   name: this.data.updateData.name,
        //   full_name: this.data.updateData.full_name,
        //   nric_no: this.data.updateData.nric_no,
        //   position: this.data.updateData.position,
        //   email: this.data.updateData.email,
        //   status: this.data.updateData.status,
        //   login_block: this.data.updateData.login_block,
        //   signing_authority: this.data.updateData.signing_authority,
        //   permissions: this.data.updateData.modules
        // }
        // this.resetPassword =  {
        //   id:this.data.updateData.account_db_code,
        //   password: "",
        //   confirmPassword: ""
        // }
      },
      resetModal() {
        this.complaint_form_file={
          id:1,
          name: "Complaint Record Form",
          status: 0,
          files: "",
          file_name: "",
          file_size: "",
        },
        this.complaint_form_qa_file={
          id:2,
          name: "Complaint Record Form (QA Section)",
          status: 0,
          files: "",
          file_name: "",
          file_size: "",
        },
        this.modalSubmit = false;
        this.modalLoading = false;
        this.formData={
          title:"",
          status: "pending",
          document_1: "",
          document_2: "",
          photos:[
            {
              id: "P1",
              name: "Photo (1)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P2",
              name: "Photo (2)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P3",
              name: "Photo (3)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P4",
              name: "Photo (4)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            }
          ]
        }
        this.formEditData={
          id:"",
          title:"",
          status: "pending",
          document_1: "",
          document_2: "",
          photos:[
            {
              id: "P1",
              name: "Photo (1)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P2",
              name: "Photo (2)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P3",
              name: "Photo (3)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            },
            {
              id:"P4",
              name: "Photo (4)",
              status: 0,
              files: "",
              file_name: "",
              file_size: "",
            }
          ]
        }
      },
      newRequest(){
        this.modalSubmit = true
        this.formData.document_1 = this.complaint_form_file.files;
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        }
        else {
          this.$Progress.start();
          this.modalLoading = true;
          var bodyFormData = new FormData();
          bodyFormData.append("accessToken", this.accessToken);
          bodyFormData.append("accessUsername", this.accessUsername);
          bodyFormData.append("title", this.formData.title);
          bodyFormData.append("document1", this.formData.document_1);
          //bodyFormData.append("document2", this.formData.document_2);
          bodyFormData.append("photos", JSON.stringify(this.formData.photos));
          axios({
              method: "post",
              //url: appConfig.APIHost + 'controller/user/createNewUser',
              url: 'https://seveninblank.com/projects/api/newReturnExchangeRequest',
              data: bodyFormData,
              headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response)=>{
              
              var resData = response.data;
              if (resData.status == 200) {
                console.log(resData)
                Swal.fire({
                  icon: 'success',
                  title: 'Return & Exchange Request Submitted',
                  html: 'Your request has been received. Our team will review it shortly.',
                  confirmButtonColor: '#FA6541',
                  confirmButtonText: this.$t('siteLang.Done')
                }).then(() => {
                  this.$refs['modal-new-request'].hide()
                  this.$emit('callParentFunction', this.formData.status);
                })
                
              } 
              else if (resData.status == 440){
                Swal.fire(
                    {
                    icon: 'error',
                    title: 'Oops...',
                    html: `${resData.message}.`,
                    confirmButtonColor: '#222',
                    confirmButtonText: this.$t('siteLang.Done'),
                  })
                  localStorage.clear();
                  this.$router.push({
                      path: "/login",
                });
              }
              else {
                  Swal.fire(
                    {
                    icon: 'error',
                    title: 'Oops...',
                    html: `${resData.message}.`,
                    confirmButtonColor: '#222',
                    confirmButtonText: this.$t('siteLang.Done'),
                  })
              }
              this.modalLoading = false;
              this.modalSubmit = false
              this.$Progress.finish();
            })
            .catch((error)=> {
                this.modalLoading = false;
                this.modalSubmit = false
                this.$Progress.finish();
                //Swal.fire("Error", error, "error");
                Swal.fire(
                  {
                  icon: 'error',
                  title: 'Oops...',
                  html: `${error}.`,
                  confirmButtonColor: '#222',
                  confirmButtonText: this.$t('siteLang.Done'),
                })
          });
        }
      },
      updateRequest(){
        this.modalSubmit = true
        if (this.complaint_form_qa_file.files){
          this.formEditData.document_2 = this.complaint_form_qa_file.files;
        }
        this.$v.formEditData.$touch();
        
        if (this.$v.formEditData.$invalid) {
          console.log("Error")
          return;
        }
        else {
          this.$Progress.start();
          this.modalLoading = true;
          var bodyFormData = new FormData();
          bodyFormData.append("accessToken", this.accessToken);
          bodyFormData.append("accessUsername", this.accessUsername);
          //bodyFormData.append("title", this.formEditData.title);
          // bodyFormData.append("document1", this.formEditData.document_1);
          bodyFormData.append("document2", this.formEditData.document_2);
          //bodyFormData.append("photos", JSON.stringify(this.formEditData.photos));
          bodyFormData.append("status", this.formEditData.status);
          bodyFormData.append("rejected_reason", this.formEditData.rejected_reason);
          axios({
              method: "post",
              //url:  appConfig.APIHost + 'controller/user/editUser',
              url: 'https://seveninblank.com/projects/api/updateReturnExchange',
              data: bodyFormData,
              headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response)=>{
              
              var resData = response.data;
              if (resData.status == 200) {
                console.log(resData)
                Swal.fire({
                  icon: 'success',
                  title: 'Request Updated',
                  html: 'The return & exchange request has been updated successfully.',
                  confirmButtonColor: '#FA6541',
                  confirmButtonText: this.$t('siteLang.Done')
                }).then(() => {
                  this.$refs['modal-update-request'].hide()
                  this.$emit('callParentFunction', this.formEditData.status);
                })
                
              } 
              else if (resData.status == 440){
                Swal.fire(
                    {
                    icon: 'error',
                    title: 'Oops...',
                    html: `${resData.message}.`,
                    confirmButtonColor: '#222',
                    confirmButtonText: this.$t('siteLang.Done'),
                  })
                  localStorage.clear();
                  this.$router.push({
                      path: "/login",
                });
              }
              else {
                  Swal.fire(
                    {
                    icon: 'error',
                    title: 'Oops...',
                    html: `${resData.message}.`,
                    confirmButtonColor: '#222',
                    confirmButtonText: this.$t('siteLang.Done'),
                  })
              }
              this.modalLoading = false;
              this.modalSubmit = false
              this.$Progress.finish();
            })
            .catch((error)=> {
                this.modalLoading = false;
                this.modalSubmit = false
                this.$Progress.finish();
                //Swal.fire("Error", error, "error");
                Swal.fire(
                  {
                  icon: 'error',
                  title: 'Oops...',
                  html: `${error}.`,
                  confirmButtonColor: '#222',
                  confirmButtonText: this.$t('siteLang.Done'),
                })
          });
        }
      },
      async reload() {
        try {
          await this.$nextTick(); // Wait for the component to be fully mounted

          const commonFunc = this.$refs.commonFunc;
          if (commonFunc && commonFunc.getFullData) {
            const data = await commonFunc.getFullData();
            this.account_type = data.account_type//data.account_type;
            const permission = data.modules.filter(e => e.name === 'returns_&_exchanges')
            if (permission) {
              this.create_modify_permission = permission[0].create_modify_permission == 0 ? false : true;
            } else {
              console.log('Module with name "returns_&_exchanges" not found.');
            }
          } else {
            // Handle the case when commonFunc or getFullData is undefined
            // Perform appropriate actions or show a fallback message to the user
          }
        } catch (error) {
          // Handle the error silently without propagating it further
        }
      },
    }
  };
</script>
<style scoped>
  label{
    margin-bottom: 5px;
  }
  #eye_current,
  #eye,
  #eye2,
  #eye3{
  position: absolute;
  top: 4px;
  padding: 5px 10px;
  right: 5px;
  text-align: center;
  width: 32px;
  color: #999;
  z-index: 3;
  background-color: #fff;
  cursor: pointer;
  }
  .custom-table td .row{
    min-width:220px;
    
  }
.square-image {
  position: relative;
  width: 100%;
  height: 0px !important;
  padding-bottom: 100% !important; /* 1:1 Aspect Ratio */
  background-color: #fff;
  border:1px solid #e0e0e0 ;
  color: #ccc;
}

.square-image img {
  position: absolute;
  border-radius: 10px !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* This makes the image cover the entire square area */
}

</style>